export const workflowTriggers = ($http: HttpApi) => ({
  update: (workflowTriggerId: string, params: HttpParams['body']) => $http.$patch(`/workflow_triggers/${workflowTriggerId}`, { body: params }),
});
